var Calculator = function(product)
{
	var _this = this;

	this.product = product;
	this.values = {};

	this.set = function(key, value) {
		console.log('Calculator: set ' + key + ': ' + value);
		this.values[key] = value;
	}

	this.get = function(key) {
		return this.values[key];
	}

	this.leenbedrag = function(callback) {
		//
	}

	this.maandlast = function(callback) {
		if(!this.values.looptijd || this.values.looptijd == 0) {
			this.values.looptijd = this.values.leenbedrag/100;
			this.product.activeStack.append('looptijd');
		}
		/*
		 * If woning is set the rent must go up with 0.2 percent. This only counts when the product is a persoonlijke lening
		 * Else the rent is the original rent
		 */
		if(_this.product.fields.woning && _this.product.fields.woning.value != 1 && _this.product.key == "persoonlijke lening"){
				var newRente = this.values.rente;
				console.log("DIT IS DE RENTE: "+newRente);
				var nominaal = (Math.pow((1 + newRente / 100),(1 / 12)) - 1) * 100;
				console.log("DIT IS DE NOMINALE RENTE: "+nominaal);
				var value = Math.round(util.annu(this.values.leenbedrag, (nominaal/100), this.values.looptijd));
				console.log("DIT IS DE ANNU: "+value);
		}else{
			var value = Math.round(util.annu(this.values.leenbedrag, (this.values.nominaal/100), this.values.looptijd));
		}
		this.set('maandlast', value);
		callback(value);
	}

	this.looptijd = function(callback) {
		console.log("NOMINAAL PERCENTAGE: "+this.values.nominaal);
		console.log("calculate looptijd with", this.values.leenbedrag, this.values.nominaal, this.values.maandlast, this.values.rente);
		var value = Math.round(util.looptijd(this.values.leenbedrag, this.values.nominaal, this.values.maandlast));
		this.set('looptijd', value);
		callback(value);
	}

	this.rente = function(callback) {
		console.log("rente", this.product.key,
			this.values.leenbedrag,
			this.values.looptijd,
			this.values.maandlast);
		$.get("/ajax/rente_dnkm.php", {
			product: this.product.key,
			leenbedrag: this.values.leenbedrag,
			looptijd: this.values.looptijd,
			maandlast: this.values.maandlast,
			type: $('#productvorm').val()
		}, function(data){
			console.log(data);
			data = Math.round(Number(data.split(";")[1]) * 10) / 10;
			var value = Math.round((data + 1) * 10) / 10;
			console.log("Woning:"+_this.product.fields.woning);
			// if(_this.product.fields.woning && _this.product.fields.woning.value != 1)
			// 	value += 0.2;
			_this.set('rente', value);
			_this.nominaal();
			callback(value);
		});
	}

	this.nominaal = function() {
		var value = (Math.pow((1 + this.values.rente / 100),(1 / 12)) - 1) * 100;
		this.set('nominaal', value);
		return value;
	}

	this.kosten = function(callback) {
		var value = this.values.looptijd * this.values.maandlast;
		this.set('kosten', value);
		callback(value);
	}

}